import { Component } from "react";
import { getFullName } from "../../service/area";

import "./index.less";

export default class AreaLabel extends Component {

  state = {
    fullName: "",
  };


  componentDidMount() {
    this.loadFullName();
  };

  loadFullName = () => {
    const { value } = this.props;
    getFullName(value).then(fullName => {
      this.setState({
        ...this.state,
        fullName,
      });
    });
  };

  render() {
    return this.state.fullName;
  };
};
